import Vue from 'vue';
import { io } from 'socket.io-client';

const URL = process.env.VUE_APP_SOCKET_CHAT_URL;
const socketChat = io(URL, { autoConnect: false, path: '/chat', transports: ['websocket'] });

// socketChat.onAny((event, ...args) => {
//   console.log(event, args);
// });

Vue.use(socketChat);

export default socketChat;
